var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	30478: {
		fallback: () => (() => (__webpack_require__(51810))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	12160: {
		fallback: () => (() => (__webpack_require__(41475))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	33545: {
		fallback: () => (() => (__webpack_require__(70118))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	73565: {
		fallback: () => (() => (__webpack_require__(71468))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	97663: {
		fallback: () => (() => (__webpack_require__(82784))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	94019: {
		fallback: () => (() => (__webpack_require__(41290))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	51186: {
		fallback: () => (__webpack_require__.e(870).then(() => (() => (__webpack_require__(98489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@sbx/sbx-deimos-reactui-common",
	},
	51905: {
		fallback: () => (() => (__webpack_require__(55914))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	54666: {
		fallback: () => (__webpack_require__.e(645).then(() => (() => (__webpack_require__(22026))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@asurion-core/mx-asurion-ui-react",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [30478,12160];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"30": [
		30478,
		12160
	],
	"489": [
		33545,
		73565,
		97663
	],
	"870": [
		97663
	],
	"928": [
		73565,
		94019,
		51186,
		33545,
		51905,
		54666
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}